import { backendApi } from "@/services/backend/api";
import { AirHandlingUnitComponent } from "@/services/backend/htz/ahu/types/air-handling-unit-component";
import { Filter } from "@/shared/lib/filter/filter";
import {
  providesEntity,
  providesList,
} from "@/services/backend/_lib/tag-helpers";
import { Lst } from "@/shared/lib/lst/lst";
import { RFC3339timestamp, UUID } from "@bitory-gmbh/nidavellir";
import { OrdrBy } from "@/shared/lib/ordr/ordrBy";

const ahuComponentApi = backendApi
  .enhanceEndpoints({
    addTagTypes: ["HtzAirHandlingUnitComponent"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      htzAirHandlingUnitComponentPut: build.mutation<
        AirHandlingUnitComponent,
        PutRequest
      >({
        query: (request) => ({
          url: `/htz/air-handling-unit-component`,
          method: "PUT",
          body: request,
        }),
        invalidatesTags: (_result, _e, request) => [
          { type: "HtzAirHandlingUnitComponent", id: request.id },
          "HtzAirHandlingUnitComponent",
        ],
      }),
      htzAirHandlingUnitComponentShow: build.query<
        AirHandlingUnitComponent,
        ShowRequest
      >({
        query: (request) => ({
          url: `/htz/air-handling-unit-component`,
          method: "GET",
          params: request,
        }),
        providesTags: providesEntity("HtzAirHandlingUnitComponent"),
      }),
      htzAirHandlingUnitComponentList: build.query<
        Lst<AirHandlingUnitComponent>,
        ListRequest
      >({
        query: (request) => ({
          url: `/htz/air-handling-unit-component/list`,
          method: "GET",
          params: {
            request: btoa(JSON.stringify(request)),
          },
        }),
        providesTags: (result) =>
          providesList(result?.items, "HtzAirHandlingUnitComponent"),
      }),
      htzAirHandlingUnitComponentDelete: build.mutation<null, DeleteRequest>({
        query: (request) => ({
          url: `/htz/air-handling-unit-component`,
          method: "DELETE",
          body: request,
        }),
        invalidatesTags: ["HtzAirHandlingUnitComponent"],
      }),
    }),
  });

export const {
  useHtzAirHandlingUnitComponentPutMutation,
  useHtzAirHandlingUnitComponentShowQuery,
  useHtzAirHandlingUnitComponentListQuery,
  useHtzAirHandlingUnitComponentDeleteMutation,
} = ahuComponentApi;

export type PutRequest = AirHandlingUnitComponent;

export interface ShowRequest {
  id: string;
}

export interface ListRequest {
  airHandlingUnit?: Filter<UUID>;
  name?: Filter<string>;
  customer?: Filter<UUID>;
  serviceObject?: Filter<UUID>;
  createdAt?: Filter<RFC3339timestamp>;
  updatedAt?: Filter<RFC3339timestamp>;
  orderBy?: OrdrBy<AhuComponentOrderBy>[];
  limit?: number;
  offset?: number;
}

export type AhuComponentOrderBy = "name" | "createdAt" | "updatedAt";

export interface DeleteRequest {
  id: string;
}
